
import React, {useState,useEffect} from 'react';
import Todolist from './TodoList';
import Notask from './Notask'
function Todoform() {

/// INPUT STATE
 let [input, setinput] = useState('')
/// ITEM STATE
 const [items, setitems] = useState([])
 const inputhandler=(e)=>{
     setinput(e.target.value)
 }
 
 /// ADD ITEM HANDLER
 const [error, seterror] = useState('Searching Your Task....')
 const additems=()=>{
    input=input.replace(/\s+/g,' ').trim()
      if(!input){
        seterror('Seems like blank input :(')
      }
      else{
        localStorage.setItem('Task',items)
        setitems([...items,input])
        setinput('')
      }
      
       
 }
 


 ///Key Handler
 const keyhandler=(e)=>{
   if(e.charCode===13){
      additems()
   }
 }
  ///Delete Item
 const [deleteditem, setdeleteditem] = useState(0)
 const deleteitem=(id)=>{
    const updated=items.filter((elem,ind)=>{
     return id!==ind
     
    })
   setdeleteditem(deleteditem+1)
   setitems(updated)
   seterror('Searching Your Task....')
     }
/// COLORS FOR TASK
 const color=['#4caf50','#f57f17','#00bcd4','#795548']
 /// TASK PROPS

 const elem=items.map((elem,pos)=>{
    return (
        <Todolist task={elem} key={pos} del={()=>{deleteitem(pos)}} color={color[pos%4]}/>
    )
 })

 
    return (
        
        <div>
            
            <div className='formtitle'>
            <h1>What's the plan for the day?</h1>
            </div>
            <div className='addtask'>
                <input type='text' placeholder='Type your task...' name='task' value={input} onChange={inputhandler} onKeyPress={keyhandler} ></input>
                <button onClick={additems}>Add Task</button>
            </div>
            <div className='taskheading'><h1>Your Task </h1>
            </div>
            <div className='taskstats'><h3>Active Task: {items.length}</h3>
            <h3>Completed Task: {deleteditem}</h3>
             </div>
            {items.length===0?<Notask error={error}/>:elem}
               
           
        </div>
    )
}

export default Todoform
